import { apiFetch, type RequestAuth } from './client';

/** One row of the Developer Portal apps list. */
export interface AppItem {
  appId: string;
  name: string;
  /** "OCP" or "ODP" — already normalized by rivendell. */
  targetProduct: string;
  /** Installs summed across shards; a lower bound when `degradedShards` is non-empty. */
  installCount: number;
}

/** rivendell `GET /dev-portal/apps`. */
export interface AppsListResponse {
  items: AppItem[];
  /** Shards rivendell couldn't reach this request; when non-empty, install counts are a lower bound. */
  degradedShards: string[];
}

export function getAppsList(auth: RequestAuth): Promise<AppsListResponse> {
  return apiFetch<AppsListResponse>('/dev-portal/apps', auth);
}

/** Target product for a new app. */
export type TargetProduct = 'OCP' | 'ODP';

/** Body for rivendell `POST /dev-portal/apps`. */
export interface RegisterAppRequest {
  appId: string;
  name: string;
  accountType: TargetProduct;
}

/** The app rivendell echoes back after creation. */
export interface RegisteredApp {
  id: string;
  name: string;
  accountType: string;
  createdAt: string;
  updatedAt: string;
}

export function registerApp(auth: RequestAuth, body: RegisterAppRequest): Promise<RegisteredApp> {
  return apiFetch<RegisteredApp>('/dev-portal/apps', auth, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
